import React from 'react';
import AdminLayout from './AdminLayout';
import PitchBookSyncTab from '../../components/pitchbook/PitchBookSyncTab';
import { usePitchbookAccess } from '../../hooks/usePitchbook';

export default function AdminPitchBookSyncPage() {
    const { hasAccess } = usePitchbookAccess();

    if (!hasAccess) {
        return (
            <AdminLayout title="PitchBook Sync">
                <p className="text-stone-500">PitchBook is not configured.</p>
            </AdminLayout>
        );
    }

    return (
        <AdminLayout title="PitchBook Sync" description="Sync PitchBook data with your CRM">
            <PitchBookSyncTab />
        </AdminLayout>
    );
}
